import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";

import { IRequestFailed, IUsedCarsState } from "./types";

const initialState: IUsedCarsState = {
  usedCars: {},
  filterCars:{},
};

const slice = createSlice({
  name: "usedCars",
  initialState,
  reducers: {
    usedCars(state, action: PayloadAction<any>) {
      state.usedCars.status = RequestStatus.RUNNING;
    },
    usedCarsSuccess(state, action) {
      state.usedCars.status = RequestStatus.SUCCESS;
      state.usedCars.data = action.payload;
    },
    usedCarsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.usedCars.status = RequestStatus.ERROR;
      state.usedCars.error = action.payload;
    },
    filterCars(state, action: PayloadAction<any>) {
      state.filterCars.status = RequestStatus.RUNNING;
    },
    filterCarsSuccess(state, action) {
      state.filterCars.status = RequestStatus.SUCCESS;
      state.filterCars.data = action.payload;
    },
    filterCarsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.filterCars.status = RequestStatus.ERROR;
      state.filterCars.error = action.payload;
    },
  },
});

export default slice.reducer;
export const { usedCars, usedCarsSuccess, usedCarsFailed ,filterCars,filterCarsFailed,filterCarsSuccess } = slice.actions;
